export default __webpack_public_path__ + "static/media/GYM.88ac9415.png";